import { render, staticRenderFns } from "./SubmitCategoryDelete.vue?vue&type=template&id=4400f1ec&scoped=true"
import script from "./SubmitCategoryDelete.vue?vue&type=script&lang=js"
export * from "./SubmitCategoryDelete.vue?vue&type=script&lang=js"
import style0 from "./SubmitCategoryDelete.vue?vue&type=style&index=0&id=4400f1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4400f1ec",
  null
  
)

export default component.exports